import Box from "@/common/components/Box";
import ResumeItem from "@/common/components/ResumeItem";
import { formatDateTime } from "@/common/utils/formatters";
import { useForwardingTabContext } from "@/features/maintenance/features/workflows/hooks/forwardings/useForwardingTabContext";
import EstablishmentChoiceEntryProposalAwaitingEstablishmentResponse from "./AwaitingEstablishmentReponse";
import { MaintenanceForwardingEstablishmentChoiceEntryProposalData } from "@/features/maintenance/features/workflows/types/forwardings/establishmentChoiceEntries/establishmentChoiceEntry.type";
import EstablishmentChoiceEntryProposalDiagnostic from "./Diagnostic";

interface EstablishmentChoiceEntryProposalProps {
  proposal: MaintenanceForwardingEstablishmentChoiceEntryProposalData;
  showProposalDiagnostic?: boolean;
}

const EstablishmentChoiceEntryProposal = ({ proposal, showProposalDiagnostic }: EstablishmentChoiceEntryProposalProps) => {
  const { forwarding } = useForwardingTabContext();

  return (
    <>
      {(proposal.status === 'awaiting_establishment_response') && (
        <EstablishmentChoiceEntryProposalAwaitingEstablishmentResponse />
      )}

      <Box className="p-4 flex flex-col gap-8">
        {(proposal.status !== 'awaiting_establishment_response') && (
          <div className="flex flex-col gap-3">
            <div>
              <p className="font-semibold">
                {proposal.id.split('-')[0]?.toUpperCase()}
              </p>
            </div>

            <div className="flex gap-3">
              {forwarding?.establishment_choice_entry?.process_started_at && (
                <ResumeItem
                  label="Data do lance"
                  value={formatDateTime(new Date(forwarding?.establishment_choice_entry?.process_started_at))}
                  className="text-xs"
                  valueClassName="font-bold text-sm"
                />
              )}
            </div>
          </div>
        )}

        {showProposalDiagnostic && (
          <div className="-mx-4 -my-4">
            <EstablishmentChoiceEntryProposalDiagnostic />
          </div>
        )}
      </Box>
    </>
  );
}

export default EstablishmentChoiceEntryProposal;
